import ChangeEntityVisibilityContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/ChangeEntityVisibilityContent";
import AbstractCommand from "../../../core/application/AbstractCommand";
import NGTScenarioPlayer from "../../../ngt/scenario/NGTScenarioPlayer";
import DashboardEvent from "../../dashboard/event/DashboardEvent";
import InternalStakeholdersModel from "../../internal-stakeholders/model/InternalStakeholdersModel";
import TimerEvent from "../../timer/event/TimerEvent";

export default class HubAvailabilityCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {InternalStakeholdersModel} internalStakeholdersModel 
     */
    constructor(dispatcher, internalStakeholdersModel) {
        super(dispatcher);
        this._dispatcher= dispatcher;

        this._internalStakeholdersModel = internalStakeholdersModel;
    }

    execute(evt) {
        const data = evt.params.data;
        /** @type {ChangeEntityVisibilityContent} */
        const content = data.content;
        /** @type {NGTScenarioPlayer} */
        const contentPlayer = data.contentPlayer;

        const entityID = content.getEntityID();
        const visibilityEntity = content.getVisible();

        // Currently dispatching start timer
        this._dispatcher.dispatch(TimerEvent.START_TIMER);

        // TODO: Improve comparaison
        if (entityID == "dashboard") {
            const dashboardVisibilityEvent = visibilityEntity ? DashboardEvent.ENABLE_DASHBOARD_BUTTON : DashboardEvent.DISABLE_DASHBOARD_BUTTON;
            this._dispatcher.dispatch(dashboardVisibilityEvent);
        } else {
            const internalStakeholder = this._internalStakeholdersModel.getInternalStakeholderById(entityID);
            if (visibilityEntity) {
                this._internalStakeholdersModel.activateInternalStakeholder(internalStakeholder);
            } else {
                this._internalStakeholdersModel.deactivateInternalStakeholder(internalStakeholder);
            }
        }




        contentPlayer.contentCompleted(content);
    }
}